<template>
  <div class="editable-text">
    <div v-if="editing">
      <Redactor
        v-bind="$attrs"
        class="editable-text__editor"
        :value="value"
        @input="(e) => $emit('input', e)"
      />
    </div>
    <div v-else>
      <i class="editable-text__icon far fa-edit" @click="editing = true" />
      <div v-html="value" />
    </div>
  </div>
</template>

<script>
import Redactor from '@/components/common/WysiwygRedactor.vue'

export default {
  name: 'EditableWysiwygText',
  components: { Redactor },
  inheritAttrs: false,
  props: {
    isOpened: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      editing: false,
    }
  },
  created() {
    this.editing = this.isOpened;
  },
  methods: {
    resetEditing() {
      this.editing = false;
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/_variables"

.editable-text__editor
  width: 100%

.editable-text__icon
  margin-right: 10px
  color: $color-text-accent-customer
  cursor: pointer

  &:hover
    color: #555555

.editable-text
  word-break: break-word

</style>
